import React, { useState } from 'react';
import moment from 'moment';
import 'moment/locale/es';

import { useForm } from '../../../hooks/useForm';
import { formValidation } from '../../../helpers/formValidation';
import { useDispatch, useSelector } from 'react-redux';
import { generatePagoEfectivo } from '../../../actions/payments';

export const Practicaja = () => {

    const dispatch = useDispatch();
    const {practicajaForm} = useSelector(state => state.forms);
    const {in_process} = useSelector(state => state.payments);
    const [{inputCantidad}, handleInputChange, reset] = useForm({
        inputCantidad: ''
    })

    const handleSubmit=(e)=>{
        formValidation(e, () => dispatch(generatePagoEfectivo(inputCantidad, e.target.name, 'practicaja', () =>reset())));
    }

    return (
        <div>
            <form 
                name="practicajaForm" 
                className="needs-validation needs-validation" 
                noValidate={true} 
                onSubmit={handleSubmit}
            >
                { moment().format('DD') >= 25
                    ? <>
                        <h4 className="text-warning">No se pueden hacer pagos en practicaja despues del día 25 de cada mes.</h4>
                        <h4>Puedes usar otro metodo de pago.</h4>
                    </>
                    : <>
                        <p>Genera y consultar tus fichas de pagos vigentes para pagar en <strong>Practicaja</strong>.</p>
                        {
                            !!practicajaForm.msg &&
                                <div className={`alert alert-${practicajaForm.error?'danger':'success'}`} role="alert">
                                    {practicajaForm.msg}
                                </div>
                        }
                        <div className="row">
                            <div className="col-md-6 mt-2">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="inputGroupPrepend">$</span>
                                    </div>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        placeholder="Cantidad a abonar" 
                                        aria-describedby="inputGroupPrepend" 
                                        name="inputCantidad"
                                        value={inputCantidad}
                                        onChange={handleInputChange}
                                        required={true} 
                                    />
                                    <div className="invalid-feedback">
                                        Ingresa una cantidad.
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 mt-2 d-flex align-content-center justify-content-center">
                                <button 
                                    className="btn btn-primary" 
                                    type="submit"
                                    disabled={!!practicajaForm.loading ? true : false}
                                >
                                    {!!practicajaForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Generar ficha de pago
                                </button>
                            </div>
                        </div>
                    </>
                }
                <div className="table-responsive-md mt-4" style={{overflowY: 'hidden'}}>
                    <table className="table table-hover table-centered text-nowrap">
                        <thead className="">
                            <tr>
                                <th>Cantidad</th>
                                <th>Vencimiento</th>
                                <th>Creación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                in_process.map((payment, pk) => ( payment.method === 'practicaja' &&
                                    <tr className="animate__animated animate__fadeInUp" key={pk}>
                                        <td>
                                            <a 
                                                href={`${process.env.REACT_APP_API_URL}/pdf/pagoEfectivo/practicaja/${payment.payment_id}`}
                                                className="text-success" 
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="fas fa-arrow-circle-down" style={{fontSize: 20}}></i>
                                            </a>
                                            &nbsp;{ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(payment.amount) }
                                        </td>
                                        <td className="text-center">{ moment(payment.due_date).format('DD/MMM/YY') }</td>                  
                                        <td className="text-center"><h5 className="m-0 font-weight-normal">{moment(payment.creation_date).format('DD/MMM/YY')}</h5></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </form>
        </div>
    )
}
